// Export an array of topics for VA 1st Grade Science
const md4thSocialStudiesQuizContent = [
 // Neighbors - Drag and Drop
 {
  "slug": "neighbors",
  "title": "Neighbors",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Virginia to one of its neighbors.",
      "options": [
        { "id": "nc", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "tn", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Virginia to its other neighbors.",
      "options": [
        { "id": "wv", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "nc2", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Tennessee, Kentucky, and West Virginia.",
      "options": [
        { "id": "tn2", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky2", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "wv2", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match North Carolina, Maryland, and Kentucky.",
      "options": [
        { "id": "nc3", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md2", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky3", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match West Virginia, Tennessee, and Maryland.",
      "options": [
        { "id": "wv3", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "tn3", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md3", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    }
  ]
},

// 5 Regions - Drag and Drop
{
  "slug": "fiveregions",
  "title": "5 Regions",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Coastal Plain to its description.",
      "options": [
        { "id": "coastal", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "tidewater", "text": "Tidewater", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "piedmont", "text": "Piedmont", "image": "", "targetText": "Rolling hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match mountain regions to their traits.",
      "options": [
        { "id": "blueridge", "text": "Blue Ridge", "image": "", "targetText": "Rounded mountains", "targetImage": "" },
        { "id": "valley", "text": "Valley & Ridge", "image": "", "targetText": "Valleys", "targetImage": "" },
        { "id": "plateau", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each region to its feature.",
      "options": [
        { "id": "piedmont2", "text": "Piedmont", "image": "", "targetText": "Rolling hills", "targetImage": "" },
        { "id": "blueridge2", "text": "Blue Ridge", "image": "", "targetText": "Appalachians", "targetImage": "" },
        { "id": "coastal2", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match regions with geography.",
      "options": [
        { "id": "valley2", "text": "Valley & Ridge", "image": "", "targetText": "Valleys", "targetImage": "" },
        { "id": "plateau2", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "piedmont3", "text": "Piedmont", "image": "", "targetText": "Hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Blue Ridge, Plateau, and Coastal Plain.",
      "options": [
        { "id": "blueridge3", "text": "Blue Ridge", "image": "", "targetText": "Rounded", "targetImage": "" },
        { "id": "plateau3", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "coastal3", "text": "Coastal Plain", "image": "", "targetText": "Low flat", "targetImage": "" }
      ]
    }
  ]
},

// Rivers - Drag and Drop
{
  "slug": "rivers",
  "title": "Rivers",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each river to a city.",
      "options": [
        { "id": "potomac", "text": "Potomac", "image": "", "targetText": "Alexandria", "targetImage": "" },
        { "id": "rapp", "text": "Rappahannock", "image": "", "targetText": "Fredericksburg", "targetImage": "" },
        { "id": "york", "text": "York", "image": "", "targetText": "Yorktown", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to other cities.",
      "options": [
        { "id": "james", "text": "James", "image": "", "targetText": "Richmond/Jamestown", "targetImage": "" },
        { "id": "potomac2", "text": "Potomac", "image": "", "targetText": "Alexandria", "targetImage": "" },
        { "id": "rapp2", "text": "Rappahannock", "image": "", "targetText": "Fredericksburg", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to where they flow.",
      "options": [
        { "id": "potomac3", "text": "Potomac", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" },
        { "id": "york2", "text": "York", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" },
        { "id": "james2", "text": "James", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to their uses.",
      "options": [
        { "id": "food", "text": "Food", "image": "", "targetText": "Rivers gave", "targetImage": "" },
        { "id": "pathway", "text": "Pathway", "image": "", "targetText": "Exploration", "targetImage": "" },
        { "id": "potomac4", "text": "Potomac", "image": "", "targetText": "City location", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match James, York, and Rappahannock.",
      "options": [
        { "id": "james3", "text": "James", "image": "", "targetText": "River", "targetImage": "" },
        { "id": "york3", "text": "York", "image": "", "targetText": "River", "targetImage": "" },
        { "id": "rapp3", "text": "Rappahannock", "image": "", "targetText": "River", "targetImage": "" }
      ]
    }
  ]
},

// Languages - Drag and Drop
{
  "slug": "languages",
  "title": "Languages",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match region to language.",
      "options": [
        { "id": "tidewater", "text": "Tidewater", "image": "", "targetText": "Algonquian", "targetImage": "" },
        { "id": "piedmont", "text": "Piedmont", "image": "", "targetText": "Siouan", "targetImage": "" },
        { "id": "valley", "text": "Valley & Ridge", "image": "", "targetText": "Iroquoian", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match groups to regions.",
      "options": [
        { "id": "powhatan", "text": "Powhatan", "image": "", "targetText": "Tidewater", "targetImage": "" },
        { "id": "monacan", "text": "Monacan", "image": "", "targetText": "Piedmont", "targetImage": "" },
        { "id": "cherokee", "text": "Cherokee", "image": "", "targetText": "Valley & Ridge", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match languages to regions.",
      "options": [
        { "id": "algonquian", "text": "Algonquian", "image": "", "targetText": "Tidewater", "targetImage": "" },
        { "id": "siouan", "text": "Siouan", "image": "", "targetText": "Piedmont", "targetImage": "" },
        { "id": "iroquoian", "text": "Iroquoian", "image": "", "targetText": "Valley & Ridge", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Cherokee, Powhatan, and Monacan.",
      "options": [
        { "id": "cherokee2", "text": "Cherokee", "image": "", "targetText": "Iroquoian", "targetImage": "" },
        { "id": "powhatan2", "text": "Powhatan", "image": "", "targetText": "Algonquian", "targetImage": "" },
        { "id": "monacan2", "text": "Monacan", "image": "", "targetText": "Siouan", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match regions to their tribes.",
      "options": [
        { "id": "valley2", "text": "Valley & Ridge", "image": "", "targetText": "Cherokee", "targetImage": "" },
        { "id": "piedmont2", "text": "Piedmont", "image": "", "targetText": "Monacan", "targetImage": "" },
        { "id": "tidewater2", "text": "Tidewater", "image": "", "targetText": "Powhatan", "targetImage": "" }
      ]
    }
  ]
},

// Surviving Seasons - Multiple Choice
{
  "slug": "survivingseasons",
  "title": "Surviving Seasons",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did Virginia Indians hunt during the winter?",
      "questionImage": "",
      "answers": [
        { "text": "Birds and other animals", "correct": true, "image": "" },
        { "text": "Corn", "correct": false, "image": "" },
        { "text": "Squash", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What foods were gathered in the spring?",
      "questionImage": "",
      "answers": [
        { "text": "Fish and berries", "correct": true, "image": "" },
        { "text": "Snow and ice", "correct": false, "image": "" },
        { "text": "Sand and shells", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What crops were grown during the summer?",
      "questionImage": "",
      "answers": [
        { "text": "Beans and corn", "correct": true, "image": "" },
        { "text": "Rice", "correct": false, "image": "" },
        { "text": "Apples", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they do in the fall?",
      "questionImage": "",
      "answers": [
        { "text": "Harvest crops", "correct": true, "image": "" },
        { "text": "Build houses", "correct": false, "image": "" },
        { "text": "Sail ships", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Virginia Indians store to survive the winter months?",
      "questionImage": "",
      "answers": [
        { "text": "Food", "correct": true, "image": "" },
        { "text": "Wood", "correct": false, "image": "" },
        { "text": "Clothing", "correct": false, "image": "" }
      ]
    }
  ]
},

// The Past - Multiple Choice
{
  "slug": "thepast",
  "title": "The Past",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What do we use to learn about people from long ago?",
      "questionImage": "",
      "answers": [
        { "text": "Archaeology", "correct": true, "image": "" },
        { "text": "Astrology", "correct": false, "image": "" },
        { "text": "Biology", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call someone who studies the past?",
      "questionImage": "",
      "answers": [
        { "text": "Archaeologist", "correct": true, "image": "" },
        { "text": "Astronaut", "correct": false, "image": "" },
        { "text": "Artist", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What archaeological site is located in southeastern Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Cactus Hill", "correct": true, "image": "" },
        { "text": "Jamestown", "correct": false, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. About how old is the Cactus Hill site?",
      "questionImage": "",
      "answers": [
        { "text": "18,000 years", "correct": true, "image": "" },
        { "text": "200 years", "correct": false, "image": "" },
        { "text": "500 years", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did archaeologists find at Cactus Hill?",
      "questionImage": "",
      "answers": [
        { "text": "Evidence of early people", "correct": true, "image": "" },
        { "text": "Gold and treasure", "correct": false, "image": "" },
        { "text": "Old maps", "correct": false, "image": "" }
      ]
    }
  ]
},

// Tribes Today - Multiple Choice
{
  "slug": "tribestoday",
  "title": "Tribes Today",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many tribes does Virginia officially recognize today?",
      "questionImage": "",
      "answers": [
        { "text": "8", "correct": true, "image": "" },
        { "text": "6", "correct": false, "image": "" },
        { "text": "10", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which tribe lives in the Piedmont Region of Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Monacan", "correct": true, "image": "" },
        { "text": "Pamunkey", "correct": false, "image": "" },
        { "text": "Rappahannock", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where are most of the other seven tribes located?",
      "questionImage": "",
      "answers": [
        { "text": "Tidewater Region", "correct": true, "image": "" },
        { "text": "Valley and Ridge Region", "correct": false, "image": "" },
        { "text": "Appalachian Plateau", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is a recognized Virginia tribe?",
      "questionImage": "",
      "answers": [
        { "text": "Pamunkey", "correct": true, "image": "" },
        { "text": "Sioux", "correct": false, "image": "" },
        { "text": "Navajo", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which pair shows related Virginia tribes?",
      "questionImage": "",
      "answers": [
        { "text": "Upper Mattaponi and Mattaponi", "correct": true, "image": "" },
        { "text": "Mohawk and Pamunkey", "correct": false, "image": "" },
        { "text": "Cherokee and Monacan", "correct": false, "image": "" }
      ]
    }
  ]
},

// Settled - Multiple Choice
{
  "slug": "settled",
  "title": "Settled",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. In what year did the English settlers establish Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "1607", "correct": true, "image": "" },
        { "text": "1619", "correct": false, "image": "" },
        { "text": "1620", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who paid the costs to start the settlement?",
      "questionImage": "",
      "answers": [
        { "text": "Stockholders", "correct": true, "image": "" },
        { "text": "Parliament", "correct": false, "image": "" },
        { "text": "Spanish explorers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where was Jamestown first settled?",
      "questionImage": "",
      "answers": [
        { "text": "On a peninsula", "correct": true, "image": "" },
        { "text": "On an island", "correct": false, "image": "" },
        { "text": "In the mountains", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why did England want colonies in America?",
      "questionImage": "",
      "answers": [
        { "text": "To find gold and wealth", "correct": true, "image": "" },
        { "text": "To build theme parks", "correct": false, "image": "" },
        { "text": "To host sports events", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What made the Jamestown site a good choice?",
      "questionImage": "",
      "answers": [
        { "text": "It was good for trade and defense", "correct": true, "image": "" },
        { "text": "It had ski slopes", "correct": false, "image": "" },
        { "text": "It had large castles", "correct": false, "image": "" }
      ]
    }
  ]
},

// Location - Multiple Choice
{
  "slug": "location",
  "title": "Location",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Jamestown was located on a what?",
      "questionImage": "",
      "answers": [
        { "text": "Peninsula", "correct": true, "image": "" },
        { "text": "Desert", "correct": false, "image": "" },
        { "text": "Plateau", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The shoreline had water deep enough for what?",
      "questionImage": "",
      "answers": [
        { "text": "Ships to dock", "correct": true, "image": "" },
        { "text": "Horses to drink", "correct": false, "image": "" },
        { "text": "Carts to cross", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What could the site be easily defended against?",
      "questionImage": "",
      "answers": [
        { "text": "Sea attacks", "correct": true, "image": "" },
        { "text": "Snowstorms", "correct": false, "image": "" },
        { "text": "Drought", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did settlers believe about the nearby water supply?",
      "questionImage": "",
      "answers": [
        { "text": "It was safe to drink", "correct": true, "image": "" },
        { "text": "It was bad for crops", "correct": false, "image": "" },
        { "text": "It came from the ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In what year did the English settlers arrive in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "1607", "correct": true, "image": "" },
        { "text": "1588", "correct": false, "image": "" },
        { "text": "1701", "correct": false, "image": "" }
      ]
    }
  ]
},

// Charters - Multiple Choice
{
  "slug": "charters",
  "title": "Charters",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who granted the Virginia Company charters?",
      "questionImage": "",
      "answers": [
        { "text": "King of England", "correct": true, "image": "" },
        { "text": "French king", "correct": false, "image": "" },
        { "text": "Spanish king", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who received the charters from the King?",
      "questionImage": "",
      "answers": [
        { "text": "Virginia Company", "correct": true, "image": "" },
        { "text": "Dutch East India Company", "correct": false, "image": "" },
        { "text": "Hudson’s Bay Company", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the charters allow the Virginia Company to do?",
      "questionImage": "",
      "answers": [
        { "text": "Create settlements", "correct": true, "image": "" },
        { "text": "Start wars", "correct": false, "image": "" },
        { "text": "Block trade", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did each charter state or describe?",
      "questionImage": "",
      "answers": [
        { "text": "Rights and laws", "correct": true, "image": "" },
        { "text": "Songs and poems", "correct": false, "image": "" },
        { "text": "Menus and meals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where were the new English settlements located?",
      "questionImage": "",
      "answers": [
        { "text": "North America", "correct": true, "image": "" },
        { "text": "Asia", "correct": false, "image": "" },
        { "text": "Africa", "correct": false, "image": "" }
      ]
    }
  ]
},

// General Assembly - Multiple Choice
{
  "slug": "generalassembly",
  "title": "General Assembly",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. In what year did the General Assembly first meet?",
      "questionImage": "",
      "answers": [
        { "text": "1619", "correct": true, "image": "" },
        { "text": "1607", "correct": false, "image": "" },
        { "text": "1620", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was part of the General Assembly?",
      "questionImage": "",
      "answers": [
        { "text": "Governor", "correct": true, "image": "" },
        { "text": "King", "correct": false, "image": "" },
        { "text": "Pope", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were the elected representatives in the Assembly called?",
      "questionImage": "",
      "answers": [
        { "text": "Burgesses", "correct": true, "image": "" },
        { "text": "Senators", "correct": false, "image": "" },
        { "text": "Lords", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Around 1640, what name did the Assembly take on?",
      "questionImage": "",
      "answers": [
        { "text": "House of Burgesses", "correct": true, "image": "" },
        { "text": "Parliament", "correct": false, "image": "" },
        { "text": "Privy Council", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who elected the Burgesses to serve in the Assembly?",
      "questionImage": "",
      "answers": [
        { "text": "Settlers", "correct": true, "image": "" },
        { "text": "King", "correct": false, "image": "" },
        { "text": "Generals", "correct": false, "image": "" }
      ]
    }
  ]
},

// The Arrival - Multiple Choice
{
  "slug": "thearrival",
  "title": "The Arrival",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did African men and women first arrive in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "1619", "correct": true, "image": "" },
        { "text": "1607", "correct": false, "image": "" },
        { "text": "1700", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who arrived in Jamestown in 1619?",
      "questionImage": "",
      "answers": [
        { "text": "Africans", "correct": true, "image": "" },
        { "text": "Pilgrims", "correct": false, "image": "" },
        { "text": "Spanish settlers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the legal status of Africans when they arrived?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people or indentured servants", "correct": true, "image": "" },
        { "text": "Landowners", "correct": false, "image": "" },
        { "text": "Colonial governors", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What industry did Africans help expand in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Tobacco", "correct": true, "image": "" },
        { "text": "Steel", "correct": false, "image": "" },
        { "text": "Silk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The arrival of more women in Jamestown made what possible?",
      "questionImage": "",
      "answers": [
        { "text": "Families and a more stable community", "correct": true, "image": "" },
        { "text": "Empires", "correct": false, "image": "" },
        { "text": "Battles", "correct": false, "image": "" }
      ]
    }
  ]
},

// Hard Living - Multiple Choice
{
  "slug": "hardliving",
  "title": "Hard Living",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What killed many settlers in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Starvation", "correct": true, "image": "" },
        { "text": "Lightning", "correct": false, "image": "" },
        { "text": "Floods", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else caused many deaths in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Disease", "correct": true, "image": "" },
        { "text": "Cold", "correct": false, "image": "" },
        { "text": "Fire", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of land did settlers build Jamestown on?",
      "questionImage": "",
      "answers": [
        { "text": "Marshy", "correct": true, "image": "" },
        { "text": "Desert", "correct": false, "image": "" },
        { "text": "Mountain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who helped lead the settlers and bring supply ships?",
      "questionImage": "",
      "answers": [
        { "text": "John Smith", "correct": true, "image": "" },
        { "text": "Thomas Jefferson", "correct": false, "image": "" },
        { "text": "Christopher Columbus", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did settlers have to do to survive?",
      "questionImage": "",
      "answers": [
        { "text": "Farm", "correct": true, "image": "" },
        { "text": "Fish only", "correct": false, "image": "" },
        { "text": "Hunt only", "correct": false, "image": "" }
      ]
    }
  ]
},

// Settlers and Natives - Drag and Drop
{
  "slug": "settlersandnatives",
  "title": "Settlers and Natives",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match who taught survival skills.",
      "options": [
        { "id": "powhatan", "text": "Chief Powhatan", "image": "", "targetText": "Survival skills", "targetImage": "" },
        { "id": "pocahontas", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" },
        { "id": "johnsmith", "text": "John Smith", "image": "", "targetText": "Trade began", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match what settlers learned.",
      "options": [
        { "id": "corn", "text": "Plant corn", "image": "", "targetText": "From Natives", "targetImage": "" },
        { "id": "skills", "text": "Survival", "image": "", "targetText": "From Powhatan", "targetImage": "" },
        { "id": "contact", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match what the Natives traded.",
      "options": [
        { "id": "tools", "text": "Tools", "image": "", "targetText": "For food", "targetImage": "" },
        { "id": "copper", "text": "Copper", "image": "", "targetText": "For goods", "targetImage": "" },
        { "id": "english", "text": "English", "image": "", "targetText": "Trade partner", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match Native groups with exchanges.",
      "options": [
        { "id": "powhatan2", "text": "Powhatan", "image": "", "targetText": "Skills", "targetImage": "" },
        { "id": "pocahontas2", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" },
        { "id": "settlers", "text": "Settlers", "image": "", "targetText": "Learned corn", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match leaders to their roles.",
      "options": [
        { "id": "powhatan3", "text": "Powhatan", "image": "", "targetText": "Chief", "targetImage": "" },
        { "id": "pocahontas3", "text": "Pocahontas", "image": "", "targetText": "Daughter", "targetImage": "" },
        { "id": "johnsmith2", "text": "John Smith", "image": "", "targetText": "Captain", "targetImage": "" }
      ]
    }
  ]
},

// Cash Crops - Multiple Choice
{
  "slug": "cashcrops",
  "title": "Cash Crops",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What were crops sometimes used as in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Money", "correct": true, "image": "" },
        { "text": "Toys", "correct": false, "image": "" },
        { "text": "Jewels", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were these kinds of money-making crops called?",
      "questionImage": "",
      "answers": [
        { "text": "Cash crops", "correct": true, "image": "" },
        { "text": "Food crops", "correct": false, "image": "" },
        { "text": "Free crops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which crop made the most money for Virginia’s economy?",
      "questionImage": "",
      "answers": [
        { "text": "Tobacco", "correct": true, "image": "" },
        { "text": "Rice", "correct": false, "image": "" },
        { "text": "Corn", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who worked the tobacco plantations?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people", "correct": true, "image": "" },
        { "text": "Kings", "correct": false, "image": "" },
        { "text": "Explorers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was brought to Virginia to provide labor for the plantations?",
      "questionImage": "",
      "answers": [
        { "text": "Africans", "correct": true, "image": "" },
        { "text": "Spanish", "correct": false, "image": "" },
        { "text": "French", "correct": false, "image": "" }
      ]
    }
  ]
},

// Old Ways - Drag and Drop
{
  "slug": "oldways",
  "title": "Old Ways",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match settlers to what they brought.",
      "options": [
        { "id": "europeans", "text": "Europeans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "africans", "text": "Africans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "architecture", "text": "Settlers", "image": "", "targetText": "Architecture", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match groups to contributions.",
      "options": [
        { "id": "europeans2", "text": "Europeans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "africans2", "text": "Africans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "settlers2", "text": "Settlers", "image": "", "targetText": "Old ways", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match regions to influences.",
      "options": [
        { "id": "europe3", "text": "Europeans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "africa3", "text": "Africans", "image": "", "targetText": "Architecture", "targetImage": "" },
        { "id": "virginia", "text": "Virginia", "image": "", "targetText": "Mix", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match old ways to settlers.",
      "options": [
        { "id": "beliefs", "text": "Beliefs", "image": "", "targetText": "Europeans", "targetImage": "" },
        { "id": "customs", "text": "Customs", "image": "", "targetText": "Africans", "targetImage": "" },
        { "id": "arch", "text": "Architecture", "image": "", "targetText": "Both", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match contributions to groups.",
      "options": [
        { "id": "euro4", "text": "Europeans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "afro4", "text": "Africans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "settle4", "text": "Settlers", "image": "", "targetText": "Architecture", "targetImage": "" }
      ]
    }
  ]
},

// Moving Capital - Multiple Choice
{
  "slug": "movingcapital",
  "title": "Moving Capital",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Where was Virginia’s first capital?",
      "questionImage": "",
      "answers": [
        { "text": "Jamestown", "correct": true, "image": "" },
        { "text": "Richmond", "correct": false, "image": "" },
        { "text": "Norfolk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why did leaders decide to move the capital from Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Diseases spread through the swampy land", "correct": true, "image": "" },
        { "text": "It was too cold in winter", "correct": false, "image": "" },
        { "text": "There were too many hills", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did the capital move after Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Williamsburg", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Boston", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did the capital move after Williamsburg?",
      "questionImage": "",
      "answers": [
        { "text": "Richmond", "correct": true, "image": "" },
        { "text": "Baltimore", "correct": false, "image": "" },
        { "text": "Atlanta", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Richmond chosen as the new capital?",
      "questionImage": "",
      "answers": [
        { "text": "It was more central and safer from attacks", "correct": true, "image": "" },
        { "text": "It had better ocean trade", "correct": false, "image": "" },
        { "text": "It had a bigger harbor", "correct": false, "image": "" }
      ]
    }
  ]
},

// Barter - Multiple Choice
{
  "slug": "barter",
  "title": "Barter",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did most people in colonial Virginia not have?",
      "questionImage": "",
      "answers": [
        { "text": "Paper money", "correct": true, "image": "" },
        { "text": "Food", "correct": false, "image": "" },
        { "text": "Homes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else did most people not have to buy things?",
      "questionImage": "",
      "answers": [
        { "text": "Coins", "correct": true, "image": "" },
        { "text": "Boats", "correct": false, "image": "" },
        { "text": "Tools", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does the word barter mean?",
      "questionImage": "",
      "answers": [
        { "text": "Trading goods and services", "correct": true, "image": "" },
        { "text": "Planting crops", "correct": false, "image": "" },
        { "text": "Marching in a parade", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What crop was used like money in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Tobacco", "correct": true, "image": "" },
        { "text": "Rice", "correct": false, "image": "" },
        { "text": "Wheat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What could colonists trade their tobacco for?",
      "questionImage": "",
      "answers": [
        { "text": "Goods and services", "correct": true, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" },
        { "text": "Sand", "correct": false, "image": "" }
      ]
    }
  ]
},

// Resources - Multiple Choice
{
  "slug": "resources",
  "title": "Resources",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What kinds of foods did most people use in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Local produce", "correct": true, "image": "" },
        { "text": "Imported fruit", "correct": false, "image": "" },
        { "text": "Canned meals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kinds of meat did they use?",
      "questionImage": "",
      "answers": [
        { "text": "Local meats", "correct": true, "image": "" },
        { "text": "Exotic fish", "correct": false, "image": "" },
        { "text": "No meat at all", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of homes did most people live in?",
      "questionImage": "",
      "answers": [
        { "text": "One-room homes", "correct": true, "image": "" },
        { "text": "Large mansions", "correct": false, "image": "" },
        { "text": "Stone castles", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What cloth did many people use for clothing?",
      "questionImage": "",
      "answers": [
        { "text": "Cotton", "correct": true, "image": "" },
        { "text": "Silk", "correct": false, "image": "" },
        { "text": "Nylon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What other materials were used to make clothes?",
      "questionImage": "",
      "answers": [
        { "text": "Wool and leather", "correct": true, "image": "" },
        { "text": "Plastic", "correct": false, "image": "" },
        { "text": "Rubber", "correct": false, "image": "" }
      ]
    }
  ]
},

// Believe - Multiple Choice
{
  "slug": "believe",
  "title": "Believe",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What slogan did colonists say to protest unfair taxes?",
      "questionImage": "",
      "answers": [
        { "text": "No taxation without representation", "correct": true, "image": "" },
        { "text": "More taxes for all", "correct": false, "image": "" },
        { "text": "Buy British goods", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who said they had the legal authority to govern the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Parliament", "correct": true, "image": "" },
        { "text": "France", "correct": false, "image": "" },
        { "text": "Spain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who did the colonists believe had the right to govern them?",
      "questionImage": "",
      "answers": [
        { "text": "Their local assemblies", "correct": true, "image": "" },
        { "text": "The royal navy", "correct": false, "image": "" },
        { "text": "City guilds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Parliament claim it could do to the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Tax the colonies", "correct": true, "image": "" },
        { "text": "Pick mayors", "correct": false, "image": "" },
        { "text": "Close ports", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why did colonists say taxes were unfair?",
      "questionImage": "",
      "answers": [
        { "text": "They had no representatives in Parliament", "correct": true, "image": "" },
        { "text": "They were too easy to pay", "correct": false, "image": "" },
        { "text": "They wanted more stamps", "correct": false, "image": "" }
      ]
    }
  ]
},

// Sides - Drag and Drop
{
  "slug": "sides",
  "title": "Sides",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each group to its position during the Revolution.",
      "options": [
        { "id": "patriots", "text": "Patriots", "image": "", "targetText": "Independence", "targetImage": "" },
        { "id": "loyalists", "text": "Loyalists", "image": "", "targetText": "Great Britain", "targetImage": "" },
        { "id": "neutrals", "text": "Neutrals", "image": "", "targetText": "No side", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each group to the force they supported.",
      "options": [
        { "id": "patriots2", "text": "Patriots", "image": "", "targetText": "Continental Army", "targetImage": "" },
        { "id": "loyalists2", "text": "Loyalists", "image": "", "targetText": "British Crown", "targetImage": "" },
        { "id": "neutrals2", "text": "Neutrals", "image": "", "targetText": "Undecided", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each description to the correct group.",
      "options": [
        { "id": "fought", "text": "Fought Britain", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "stayed", "text": "Stayed loyal to the king", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "neither", "text": "Did not choose a side", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each goal to the group that wanted it.",
      "options": [
        { "id": "freedom", "text": "Independence", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "king", "text": "Support the king", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "peace", "text": "Avoid war", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each side to its allegiance.",
      "options": [
        { "id": "usa", "text": "New nation", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "gb", "text": "Great Britain", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "none", "text": "No allegiance", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    }
  ]
},

// Battles - Multiple Choice
{
  "slug": "battles",
  "title": "Battles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was the first land battle fought in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Great Bridge", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Saratoga", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What happened to the British governor after the Battle of Great Bridge?",
      "questionImage": "",
      "answers": [
        { "text": "He fled Norfolk", "correct": true, "image": "" },
        { "text": "He won the city", "correct": false, "image": "" },
        { "text": "He held a trial", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the last major battle of the American Revolution?",
      "questionImage": "",
      "answers": [
        { "text": "Yorktown", "correct": true, "image": "" },
        { "text": "Bunker Hill", "correct": false, "image": "" },
        { "text": "Trenton", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the result of the Battle of Yorktown?",
      "questionImage": "",
      "answers": [
        { "text": "British surrender", "correct": true, "image": "" },
        { "text": "British victory", "correct": false, "image": "" },
        { "text": "Stalemate", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the victory at Yorktown lead to?",
      "questionImage": "",
      "answers": [
        { "text": "The end of the war", "correct": true, "image": "" },
        { "text": "New taxes", "correct": false, "image": "" },
        { "text": "More battles", "correct": false, "image": "" }
      ]
    }
  ]
},

// Founders - Drag and Drop
{
  "slug": "founders",
  "title": "Founders",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each founder to their important contribution.",
      "options": [
        { "id": "washington", "text": "George Washington", "image": "", "targetText": "Father of our country", "targetImage": "" },
        { "id": "jefferson", "text": "Thomas Jefferson", "image": "", "targetText": "Religious freedom", "targetImage": "" },
        { "id": "lincoln", "text": "Abraham Lincoln", "image": "", "targetText": "Ended slavery", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each office or title to the person who held it.",
      "options": [
        { "id": "firstpres", "text": "1st President", "image": "", "targetText": "George Washington", "targetImage": "" },
        { "id": "sixteenth", "text": "16th President", "image": "", "targetText": "Abraham Lincoln", "targetImage": "" },
        { "id": "writer", "text": "Wrote the Statute for Religious Freedom", "image": "", "targetText": "Thomas Jefferson", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each role to the correct founder.",
      "options": [
        { "id": "doc", "text": "Leader in writing the Declaration of Independence", "image": "", "targetText": "Thomas Jefferson", "targetImage": "" },
        { "id": "nickname", "text": "Known as the Father of our Country", "image": "", "targetText": "George Washington", "targetImage": "" },
        { "id": "abolish", "text": "Helped end slavery in the U.S.", "image": "", "targetText": "Abraham Lincoln", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each founder’s name to their lasting achievement.",
      "options": [
        { "id": "wash2", "text": "George Washington", "image": "", "targetText": "1st President of the U.S.", "targetImage": "" },
        { "id": "jeff2", "text": "Thomas Jefferson", "image": "", "targetText": "Supported Religious Freedom", "targetImage": "" },
        { "id": "lin2", "text": "Abraham Lincoln", "image": "", "targetText": "Ended Slavery", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each phrase to the founder it describes.",
      "options": [
        { "id": "father", "text": "Father of our country", "image": "", "targetText": "George Washington", "targetImage": "" },
        { "id": "freedom", "text": "Religious freedom", "image": "", "targetText": "Thomas Jefferson", "targetImage": "" },
        { "id": "slavery", "text": "Ended slavery", "image": "", "targetText": "Abraham Lincoln", "targetImage": "" }
      ]
    }
  ]
},

// Moving - Multiple Choice
{
  "slug": "moving",
  "title": "Moving",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did many Virginians move west?",
      "questionImage": "",
      "answers": [
        { "text": "After the American Revolution", "correct": true, "image": "" },
        { "text": "Before 1600", "correct": false, "image": "" },
        { "text": "After 1900", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were Virginians seeking when they moved west?",
      "questionImage": "",
      "answers": [
        { "text": "Farmland", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Beaches", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else drew Virginians to move west?",
      "questionImage": "",
      "answers": [
        { "text": "New opportunities", "correct": true, "image": "" },
        { "text": "Snowstorms", "correct": false, "image": "" },
        { "text": "Famine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Virginians carry with them when they moved west?",
      "questionImage": "",
      "answers": [
        { "text": "Ideas", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else did Virginians take west with them?",
      "questionImage": "",
      "answers": [
        { "text": "Their cultures and traditions", "correct": true, "image": "" },
        { "text": "City walls", "correct": false, "image": "" },
        { "text": "Palaces", "correct": false, "image": "" }
      ]
    }
  ]
},

// Civil War Causes - Multiple Choice
{
  "slug": "civilwarcauses",
  "title": "Civil War Causes",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Missouri Compromise do?",
      "questionImage": "",
      "answers": [
        { "text": "Split the nation into free and slave states", "correct": true, "image": "" },
        { "text": "Ended slavery everywhere", "correct": false, "image": "" },
        { "text": "Banned all farming", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Fugitive Slave Law require people to do?",
      "questionImage": "",
      "answers": [
        { "text": "Capture escaped enslaved people", "correct": true, "image": "" },
        { "text": "Free enslaved people", "correct": false, "image": "" },
        { "text": "End all taxes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Dred Scott case decide?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people were property, not citizens", "correct": true, "image": "" },
        { "text": "Enslaved people were free in the North", "correct": false, "image": "" },
        { "text": "Enslaved people could vote", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led a raid to end slavery at Harpers Ferry?",
      "questionImage": "",
      "answers": [
        { "text": "John Brown", "correct": true, "image": "" },
        { "text": "Abraham Lincoln", "correct": false, "image": "" },
        { "text": "Jefferson Davis", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What event officially started the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "The attack on Fort Sumter", "correct": true, "image": "" },
        { "text": "The Battle of Bull Run", "correct": false, "image": "" },
        { "text": "The Battle of Gettysburg", "correct": false, "image": "" }
      ]
    }
  ]
},

// Virginia Battles - Multiple Choice
{
  "slug": "virginiabattles",
  "title": "Virginia Battles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was the first Civil War battle in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Bull Run", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Antietam", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led the Confederate soldiers at the Battle of Bull Run?",
      "questionImage": "",
      "answers": [
        { "text": "Stonewall Jackson", "correct": true, "image": "" },
        { "text": "Ulysses S. Grant", "correct": false, "image": "" },
        { "text": "William Sherman", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led the Confederate army to victory at Fredericksburg in 1862?",
      "questionImage": "",
      "answers": [
        { "text": "Robert E. Lee", "correct": true, "image": "" },
        { "text": "Abraham Lincoln", "correct": false, "image": "" },
        { "text": "Union Army", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which Virginia city fell to the Union army in 1864?",
      "questionImage": "",
      "answers": [
        { "text": "Richmond", "correct": true, "image": "" },
        { "text": "Atlanta", "correct": false, "image": "" },
        { "text": "Norfolk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did General Robert E. Lee surrender to end the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "Appomattox", "correct": true, "image": "" },
        { "text": "Gettysburg", "correct": false, "image": "" },
        { "text": "Manassas", "correct": false, "image": "" }
      ]
    }
  ]
},

// Reconstruction - Multiple Choice
{
  "slug": "reconstruction",
  "title": "Reconstruction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What period followed the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "Reconstruction", "correct": true, "image": "" },
        { "text": "Depression", "correct": false, "image": "" },
        { "text": "Colonial", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was destroyed in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Railroads", "correct": true, "image": "" },
        { "text": "Airports", "correct": false, "image": "" },
        { "text": "Skyscrapers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helped freed African Americans?",
      "questionImage": "",
      "answers": [
        { "text": "Freedmen’s Bureau", "correct": true, "image": "" },
        { "text": "Congress", "correct": false, "image": "" },
        { "text": "Supreme Court", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Freedmen’s Bureau provide?",
      "questionImage": "",
      "answers": [
        { "text": "Food and schools", "correct": true, "image": "" },
        { "text": "Weapons", "correct": false, "image": "" },
        { "text": "Taxes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else did the economy lose?",
      "questionImage": "",
      "answers": [
        { "text": "Crops", "correct": true, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" },
        { "text": "Mines", "correct": false, "image": "" }
      ]
    }
  ]
}


]

export default md4thSocialStudiesQuizContent;
